import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import Header from "../UI/Header";
import Table from "../UI/Table";
import FilterContainer from "./../UI/Filters";
import { DatePicker } from "./../UI/Filters/DateRangePicker";
import MultiSelect from "./../UI/Filters/MultiSelect";
import SingleSelect from "./../UI/Filters/SingleSelect";
import { getBuyerPerformance } from "store/actions/ReportsAction";
import Loader from "components/UI/InlineLoader";

const LIMIT = 20;
const HEADINGS = [
  "BUYER",
  "DESIGNS CREATED",
  "TOTAL VOLUME",
  "AVG. PURCHASE COST",
  "AVG. SAMPLE APPROVAL TIME"
];

const TOOLTIP_DATA = {
  "AVG. PURCHASE COST": `<div class="subtext">The average of all quotes approved for the designs created</div>`,
  "AVG. SAMPLE APPROVAL TIME": `<div class="subtext">The average time taken to approve the sample after it is dispatched by the factory</div>`
};

const BuyerPerformance = ({
  getBuyerPerformance,
  buyerPerformance = { list: [] },
  loading,
  brandsList,
  userDetails,
  isBrandManager
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [filters, setFilters] = useState({});
  const [dates, setDates] = useState({});

  useEffect(() => {
    getBuyerPerformance({ isInit: 1 });
  }, []);

  const paginationHandler = values => {
    if (
      values.offset &&
      buyerPerformance.list.length <= (currentIndex + 1) * LIMIT
    ) {
      setCurrentIndex(currentIndex + 1);
      getBuyerPerformance({
        offset: buyerPerformance.pagination.nextOffset,
        ...filters
      });
    } else {
      if (values.offset || (!values.offset && values.isnext === 1)) {
        setCurrentIndex(currentIndex + 1);
      } else if (values.isnext === 0) {
        setCurrentIndex(currentIndex - 1);
      }
    }
  };

  if (loading) {
    return <Loader />;
  }

  const getOverallReport = () => {
    return getBuyerPerformance({
      ...filters,
      limit: buyerPerformance.pagination.totalCount,
      skipStore: true,
      inlineLoader: false
    }).then(data => {
      return data.records;
    });
  };

  return (
    <div className="report-content">
      <Header
        heading="Buyer Performance"
        reportType="buyerPerformance"
        pagination={buyerPerformance.pagination}
        currentIndex={currentIndex}
        paginationHandler={paginationHandler}
        getOverallReport={getOverallReport}
        headings={HEADINGS}
      />
      <FilterContainer
        updateFilters={() => {
          getBuyerPerformance({
            ...filters,
            ...dates,
            isInit: 1
          });
          setCurrentIndex(0);
        }}
      >
        {userDetails.isSuperAdmin && (
          <SingleSelect
            label="Brand"
            filterOptions={brandsList}
            onChange={id => {
              setFilters({ ...filters, brandId: id ? id : null });
            }}
            selectedFilters={filters.brandId}
          />
        )}
        <DatePicker
          label="Date Range"
          updateFilterDates={dates => setDates(dates)}
          selectedDates={dates}
        />
        <MultiSelect
          label="Buyer"
          filterOptions={buyerPerformance.filters.buyers}
          onChange={ids => {
            setFilters({ ...filters, buyerIds: ids ? ids.join() : null });
          }}
          selectedFilters={filters.buyerIds}
        />
      </FilterContainer>

      <Table
        headings={HEADINGS}
        tooltipData={TOOLTIP_DATA}
        data={buyerPerformance.list.slice(
          currentIndex * LIMIT,
          currentIndex * LIMIT + LIMIT
        )}
        gridTemplateColumns="
    minmax(170px, 1.5fr)
    minmax(130px, 1.18fr)
    minmax(110px, 1fr)
    minmax(172px, 1.38fr)
    minmax(218px, 1.8fr)
    "
      />
    </div>
  );
};

const mapStateToProps = state => ({
  buyerPerformance: state.reports.buyerPerformance,
  loading: state.reports.loading,
  userDetails: state.auth.userDetails
});

export default connect(mapStateToProps, {
  getBuyerPerformance
})(BuyerPerformance);
